export default __webpack_public_path__ + "static/media/panel.a056e6b1.svg";